import { Helpers } from '../../helpers';
import { ITract } from '../../interfaces/itract';
import { Lease } from '../lease';

export class TractBase {
  TractId: number;
  Name: string;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  Leases_Tract?: Array<Lease> | null;

  constructor(item?: ITract) {
    if (item) {

      this.TractId = item.TractId;
      this.Name = item.Name;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.Leases_Tract = Helpers.createClassArray(Lease, item.Leases_Tract);
    }
  }
}